import { reskinStyles } from 'core/components/theme/theme-variant';
import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  linkButton: {
    height: 36,
    width: 36
  },
  rightLabel: {
    fontSize: 14,
    display: 'inline',
    marginRight: theme.spacing(2)
  },
  rightValue: {
    fontSize: 14,
    display: 'inline'
  },
  link: {
    color: theme.colors.action_text,
    fontWeight: 500,
    // The global `a` rule sets display: contents, which leaves no box to draw the hover underline on
    display: 'inline',
    '&:hover': {
      textDecoration: 'underline'
    },
    ...reskinStyles(theme, theme.actionStyles.link)
  }
});

export default makeStyles(styles);
